export enum RlgStatusT {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export interface RlgConfigT {
  status: RlgStatusT;
  reason?: string;
}

export interface ConfiguredCountryT {
  salesChannelId: string;
  countryCode: string;
  rlg: RlgConfigT;
  // Configured countries carry additional, UI-irrelevant fields that
  // must be preserved as-is when the object is sent back on update.
  [key: string]: unknown;
}

export interface SelectedReturnServiceProviderT {
  id: string;
  configuredCountries: ConfiguredCountryT[];
  [key: string]: unknown;
}
